<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">

        <div class="mt-4 mb-4 text-center">
            <h2 class="fw-bold mb-0" style="color:#1a202c;">Graph Permission Tier Review</h2>
            <p class="text-muted mt-1 mb-0" style="font-size:.9rem;">
                These Microsoft Graph permissions were detected but have not yet been reviewed by Chevron —
                until reviewed, they are treated as Tier 0 so nothing slips through unflagged.
            </p>
        </div>

        @if (isLoading) {
        <div class="text-center py-5">
            <div class="mb-3" style="display:inline-block;"><mat-spinner [diameter]="40"></mat-spinner></div>
            <p class="text-muted">Loading Graph permission reviews...</p>
        </div>
        }

        @if (!isLoading && loadErrorMessage) {
        <div class="alert alert-danger">{{ loadErrorMessage }}</div>
        }

        @if (!isLoading && !loadErrorMessage && allRows.length === 0) {
        <div class="text-center py-5 text-muted">
            <p class="mb-0">No Graph permissions found.</p>
        </div>
        }

        @if (!isLoading && !loadErrorMessage && allRows.length > 0) {

        <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="gap:1rem;background:#f8fafc;border:1px solid #eef0f3;border-radius:8px;">
            <div class="position-relative" style="max-width:300px;width:100%;">
                <mat-icon style="position:absolute;left:10px;top:50%;transform:translateY(-50%);font-size:1rem;height:1rem;width:1rem;color:#9ca3af;pointer-events:none;">search</mat-icon>
                <input class="form-control" style="border:1px solid #e2e8f0;box-shadow:none;font-size:.83rem;padding-left:32px;background:white;"
                    placeholder="Search permissions…" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" />
            </div>
            <span class="text-muted" style="font-size:.78rem;white-space:nowrap;">{{ filteredRows.length }} of {{ allRows.length }} permissions</span>
        </div>

        <!-- Bulk action bar is rendered at the bottom of the page, after the table (see below). -->

        <!-- Needs Review / Reviewed -->
        <div class="d-flex mb-3" style="gap:1.5rem;border-bottom:1px solid #e5e7eb;">
            <button type="button" class="d-flex align-items-center pb-2" style="border:none;background:none;gap:.4rem;font-size:.9rem;margin-bottom:-1px;"
                [style.borderBottom]="activeTab === 'needsReview' ? '2px solid #1a202c' : '2px solid transparent'"
                [style.color]="activeTab === 'needsReview' ? '#1a202c' : '#6b7280'"
                [style.fontWeight]="activeTab === 'needsReview' ? '600' : '500'"
                (click)="switchTab('needsReview')">
                Needs Review
                <span style="font-size:.78rem;font-weight:500;color:#e8a23d;">({{ needsReviewRows.length }})</span>
            </button>
            <button type="button" class="d-flex align-items-center pb-2" style="border:none;background:none;gap:.4rem;font-size:.9rem;margin-bottom:-1px;"
                [style.borderBottom]="activeTab === 'reviewed' ? '2px solid #1a202c' : '2px solid transparent'"
                [style.color]="activeTab === 'reviewed' ? '#1a202c' : '#6b7280'"
                [style.fontWeight]="activeTab === 'reviewed' ? '600' : '500'"
                (click)="switchTab('reviewed')">
                Reviewed
                <span class="text-muted" style="font-size:.78rem;font-weight:500;">({{ reviewedRows.length }})</span>
            </button>
        </div>

        @if (activeRows.length === 0) {
        <div class="text-center py-4 text-muted mb-4" style="background:#fafbfc;border:1px solid #eef0f3;border-radius:8px;font-size:.85rem;">
            @if (activeTab === 'needsReview') {
            Nothing awaiting review{{ searchTerm ? ' matching your search' : '' }}.
            } @else {
            No reviewed permissions{{ searchTerm ? ' matching your search' : '' }}.
            }
        </div>
        } @else {
        <div class="mb-2" style="background:white;border:1px solid #eef0f3;border-radius:8px;overflow:hidden;">
            <table class="table mb-0" style="font-size:.85rem;">
                <thead style="background:#fafbfc;border-bottom:1px solid #eef0f3;">
                    <tr>
                        <th class="px-3 py-2" style="border:none;width:36px;">
                            <input type="checkbox" [checked]="isAllSelected(pagedSlice(activeRows, page))"
                                (change)="toggleSelectAll(pagedSlice(activeRows, page))" />
                        </th>
                        <th class="py-2 fw-semibold text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;border:none;width:44%;">Permission</th>
                        <th class="py-2 fw-semibold text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;border:none;width:14%;">Tier</th>
                        <th class="py-2 pe-3 fw-semibold text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;border:none;">Approver</th>
                        <th class="py-2 pe-3 fw-semibold text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;border:none;">Reviewer</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of pagedSlice(activeRows, page); track row.permissionId) {
                    <tr style="border-top:1px solid #f5f6f8;" [style.background]="isSelected(row) ? '#f8fafc' : 'transparent'">
                        <td class="px-3 py-3" style="border:none;vertical-align:top;">
                            <input type="checkbox" [checked]="isSelected(row)" (change)="toggleSelected(row)" />
                        </td>
                        <td class="py-3" style="border:none;vertical-align:top;">
                            <div class="fw-semibold" style="color:#1f2937;">{{ row.name }}</div>
                            <div class="text-muted" style="font-size:.76rem;line-height:1.4;max-width:440px;">
                                {{ row.description || '(no description provided by Microsoft)' }}
                            </div>
                        </td>
                        <td class="py-3" style="border:none;vertical-align:top;">
                            <span class="d-inline-block fw-medium" style="border-radius:6px;padding:.15rem .55rem;font-size:.76rem;" [ngStyle]="tierBadgeStyle(row.tier)">
                                {{ tierLabels[row.tier] }}
                            </span>
                        </td>
                        <td class="py-3 pe-3" style="border:none;vertical-align:top;color:#4b5563;font-size:.82rem;">
                            @if (row.approverDisplayNames.length > 0) {
                            <div class="d-flex flex-wrap" style="gap:.25rem;">
                                @for (name of row.approverDisplayNames; track name) {
                                <span class="d-inline-block" style="background:#eef2ff;color:#3730a3;border-radius:12px;padding:.05rem .55rem;font-size:.76rem;">{{ name }}</span>
                                }
                            </div>
                            } @else {
                            <span>—</span>
                            }
                        </td>
                        <td class="py-3 pe-3" style="border:none;vertical-align:top;color:#4b5563;font-size:.82rem;">
                            @if (row.reviewerDisplayName) {
                            <span class="d-inline-block" style="background:#eef2ff;color:#3730a3;border-radius:12px;padding:.05rem .55rem;font-size:.76rem;">{{ row.reviewerDisplayName }}</span>
                            } @else {
                            <span>—</span>
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        @if (totalPages(activeRows) > 1) {
        <div class="d-flex justify-content-between align-items-center mb-4">
            <span class="text-muted" style="font-size:.78rem;">
                Showing {{ (page - 1) * pageSize + 1 }}–{{ Math.min(page * pageSize, activeRows.length) }} of {{ activeRows.length }}
            </span>
            <div class="d-flex align-items-center" style="gap:.5rem;">
                <button class="btn btn-link btn-sm text-muted" style="text-decoration:none;padding:0;" [disabled]="page === 1" (click)="goToPage(activeRows, page - 1)">‹ Prev</button>
                <span class="text-muted" style="font-size:.78rem;">Page {{ page }} of {{ totalPages(activeRows) }}</span>
                <button class="btn btn-link btn-sm text-muted" style="text-decoration:none;padding:0;" [disabled]="page === totalPages(activeRows)" (click)="goToPage(activeRows, page + 1)">Next ›</button>
            </div>
        </div>
        }
        }

        <!-- Bulk action bar: the only way to change tier/approver — select one or many rows, set values here, apply. -->
        @if (selectedIds.size > 0) {
        <div class="d-flex align-items-center justify-content-center flex-wrap px-4 py-3" style="gap:2rem;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;position:sticky;bottom:1rem;z-index:10;">
            <div class="text-center">
                <div class="text-muted" style="font-size:.7rem;text-transform:uppercase;letter-spacing:.05em;">Selected</div>
                <div class="fw-semibold" style="font-size:.95rem;color:#374151;">{{ selectedIds.size }}</div>
            </div>

            <div style="width:1px;align-self:stretch;background:#e5e7eb;"></div>

            <div class="text-center">
                <div class="text-muted mb-1" style="font-size:.7rem;text-transform:uppercase;letter-spacing:.05em;">Set tier</div>
                <div class="position-relative d-inline-block">
                    <button type="button" class="d-flex align-items-center fw-medium" style="border:none;border-radius:6px;gap:.4rem;min-width:130px;padding:.3rem .6rem;font-size:.8rem;"
                        [ngStyle]="tierBadgeStyle(bulkTier)" (click)="toggleBulkTierMenu($event)">
                        {{ tierLabels[bulkTier] }}
                        <mat-icon style="font-size:1rem;height:1rem;width:1rem;margin-left:auto;">expand_more</mat-icon>
                    </button>
                    @if (isBulkTierMenuOpen) {
                    <div (click)="$event.stopPropagation()" style="position:absolute;bottom:calc(100% + 4px);left:0;background:white;border:1px solid #e5e7eb;border-radius:8px;box-shadow:0 8px 24px rgba(15,23,42,.12);z-index:50;min-width:150px;padding:4px;">
                        @for (tier of tierOptions; track tier) {
                        <button type="button" class="tier-option d-flex align-items-center w-100 text-start" [class.selected]="tier === bulkTier" style="border:none;background:none;border-radius:6px;padding:6px 10px;gap:.5rem;font-size:.82rem;"
                            (click)="selectBulkTier(tier)">
                            <span style="width:7px;height:7px;border-radius:50%;display:inline-block;" [ngStyle]="{background: tierBadgeStyle(tier).color}"></span>
                            <span class="flex-grow-1">{{ tierLabels[tier] }}</span>
                            @if (tier === bulkTier) {
                            <mat-icon style="font-size:1rem;height:1rem;width:1rem;color:#4f46e5;">check</mat-icon>
                            }
                        </button>
                        }
                    </div>
                    }
                </div>
            </div>

            <div style="width:1px;align-self:stretch;background:#e5e7eb;"></div>

            <div class="text-center">
                <div class="text-muted mb-1" style="font-size:.7rem;text-transform:uppercase;letter-spacing:.05em;">Set approver(s)</div>
                <div class="d-flex align-items-center flex-wrap" style="gap:.3rem;max-width:320px;">
                    @for (approver of bulkApprovers; track approver.value) {
                    <mat-chip style="background-color:#0066B2;min-height:26px;">
                        <mat-label style="color:white;font-size:.78rem;">{{ approver.displayName }}</mat-label>
                        <button (click)="removeBulkApprover(approver.value)" matChipRemove>
                            <mat-icon style="color:white;">cancel</mat-icon>
                        </button>
                    </mat-chip>
                    }
                    <button type="button" class="d-flex align-items-center" style="border:1px solid #d1d5db;border-radius:6px;background:white;padding:.2rem .5rem;gap:.3rem;font-size:.78rem;"
                        (click)="addBulkApprover()">
                        <mat-icon style="font-size:1rem;height:1rem;width:1rem;color:#9ca3af;">person_add</mat-icon>
                        <span class="text-muted">Add…</span>
                    </button>
                </div>
            </div>

            <div style="width:1px;align-self:stretch;background:#e5e7eb;"></div>

            <div class="d-flex align-items-center" style="gap:.5rem;">
                <button class="btn btn-sm btn-primary" style="font-weight:500;" [disabled]="isBulkSaving || bulkApprovers.length === 0" (click)="applyBulk()">
                    {{ isBulkSaving ? 'Saving…' : 'Apply to ' + selectedIds.size }}
                </button>
                <button class="btn btn-sm text-muted" style="text-decoration:none;" (click)="clearSelection()">Clear</button>
            </div>
        </div>
        }

        }

    </section>
</main>

